export default __webpack_public_path__ + "static/media/kids-poor.ea99dfbf.jpg";